<div
  class="column-layout"
  style="justify-content: stretch; height: inherit; margin: 0"
  #wrapper
>
  <h2 mat-dialog-title #title style="text-align: center; height: 48x">
    {{ dialogTitle }}
  </h2>

  <mat-dialog-content
    class="mat-typography"
    style="flex: 1; padding-bottom: 1rem"
    #cnt
  >
    <div
      id="mcinnercontent"
      style="
        position: relative;
        top: 0;
        left: 0;
        justify-content: stretch;
        height: 100%;
      "
      class="column-layout"
    >
      <div
        class="row-layout"
        style="justify-content: center; flex: 1; overflow: auto"
        #innercnt
      >
        <video
          autoplay
          playsinline
          [ngClass]="videoElemCls"
          #vs
          style="max-width: 88vw; max-height: 88vh"
        ></video>

        <img #imgview class="hidden" />
        <canvas id="photo" class="hidden"></canvas>
        <video
          controls
          class="hidden"
          style="max-width: 88vw; max-height: 88vh"
          id="vid2"
        ></video>
      </div>
      <div class="row-layout" style="padding: 16px 0 0 0" #info>
        <div style="margin-right: 1rem">
          <mat-form-field>
            <mat-label>Dokumenttyp</mat-label>
            <mat-select [(value)]="selectedType">
              <mat-option *ngFor="let t of types" [value]="t">
                {{ t.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div style="flex: 1">
          <app-input
            label="Dokumentname"
            [(value)]="fileName"
            placeholder="Wenn leer dann wird Dateiname automatisch erzeugt"
          ></app-input>
        </div>
      </div>
    </div>
  </mat-dialog-content>
  <div
    mat-dialog-actions
    #actions
    class="row-layout flex-content-end pdf-dialog-actions"
    style="padding: 0.5rem 1.5rem 1rem 1.5rem"
  >
    <!-- height: 56px-->
    <div style="flex: 1; margin-right: 1.5rem">
      <app-upload-progress-bar
        *ngIf="isUploading"
        [data]="progressData"
      ></app-upload-progress-bar>
      <app-image-scale-tray
        *ngIf="isPhoto"
        [resolutions]="imageResolutions"
        [types]="imageTypes"
        [selected-res-id]="imageResId"
        [selected-type-id]="imageTypeId"
        (res-change)="onResChange($event)"
        (type-change)="onTypeChange($event)"
      ></app-image-scale-tray>
    </div>
    <form>
      <button mat-button class="document-cancel" (click)="close()" style="margin-right: 2rem">
        Abbrechen
      </button>
      <button
        mat-button
        [disabled]="!canSave"
        class="document-save"
        style="margin-right: 2rem"
        (click)="save()"
      >
        Speichern
      </button>
      <!--
    *ngIf="isVideo"
  -->
      <button
        mat-button
        *ngIf="isSaved"
        class="document-save"
        (click)="reset()"
      >
        Verwerfen
      </button>
      <button
        mat-button
        *ngIf="isVideo && !isSaved"
        class="document-save"
        (click)="record()"
      >
        {{ recordTitle }}
      </button>
      <button
        mat-button
        *ngIf="isPhoto && !isSaved"
        class="document-save"
        (click)="takePhoto()"
      >
        {{ photoTitle }}
      </button>
    </form>
  </div>
</div>
